<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21.396"
    height="25.614"
    viewBox="0 0 21.396 25.614"
  >
    <g transform="translate(-389.302 -387.193)">
      <path
        d="M399.7,412.806a.5.5,0,0,1-.467-.321c-1.628-4.22-5.5-8.932-9.48-9.352a.5.5,0,0,1-.085-.978c.079-.022,7.9-2.342,9.546-9.039a.5.5,0,0,1,.482-.38.528.528,0,0,1,.487.373c1.342,5.1,8.692,9.045,8.765,9.084a.5.5,0,0,1-.015.893c-.075.036-7.548,3.724-8.744,9.324a.5.5,0,0,1-.45.394Zm-8.152-10.282c3.626,1.273,6.545,5.168,8.064,8.328,1.626-4.249,6.185-7.172,8.067-8.232-1.818-1.087-6.185-4-7.948-7.833C397.991,399.216,393.849,401.537,391.544,402.524Z"
        fill="#777"
      />
      <path
        d="M406.672,398.193a.5.5,0,0,1-.467-.32c-.6-1.569-2.021-3.317-3.455-3.465a.5.5,0,0,1-.087-.978c.029-.009,2.923-.873,3.524-3.318a.5.5,0,0,1,.481-.381.484.484,0,0,1,.487.373c.491,1.861,3.25,3.35,3.278,3.365a.5.5,0,0,1-.016.891c-.028.014-2.82,1.394-3.256,3.437a.5.5,0,0,1-.45.394Zm-2.477-4.332a7.008,7.008,0,0,1,2.427,2.585,7.757,7.757,0,0,1,2.592-2.55,8.838,8.838,0,0,1-2.507-2.391A6.118,6.118,0,0,1,404.2,393.861Z"
        fill="#777"
      />
      <path
        d="M395.112,394.462a.5.5,0,0,1-.466-.32c-.428-1.109-1.591-2.729-2.838-2.861a.5.5,0,0,1-.087-.977c.024-.007,2.411-.723,2.9-2.731a.5.5,0,0,1,.482-.38.494.494,0,0,1,.487.373c.4,1.533,2.692,2.764,2.715,2.776a.5.5,0,0,1-.016.892c-.023.011-2.335,1.155-2.693,2.832a.5.5,0,0,1-.45.394Zm-1.922-3.716a6.05,6.05,0,0,1,1.88,2.011,6.636,6.636,0,0,1,2.033-1.985,7.535,7.535,0,0,1-1.957-1.856A5.226,5.226,0,0,1,393.19,390.746Z"
        fill="#777"
      />
      <path
        d="M392.265,412.807a.5.5,0,0,1-.466-.32c-.371-.96-1.239-2-2.05-2.09a.5.5,0,0,1-.088-.976,3.228,3.228,0,0,0,2.132-2.027.5.5,0,0,1,.956.038c.243.924,1.522,1.776,1.994,2.027a.5.5,0,0,1-.015.891c-.018.008-1.715.849-1.974,2.061a.5.5,0,0,1-.449.394Zm-1.221-2.932a4.676,4.676,0,0,1,1.192,1.293,5.212,5.212,0,0,1,1.323-1.279,5.828,5.828,0,0,1-1.289-1.226A4.239,4.239,0,0,1,391.044,409.875Z"
        fill="#777"
      />
    </g>
  </svg>
</template>
